import request from '@/utils/service';
// 获取组织根目录
export const organizations = params => {
    return request({
        url: 'api-auth/organizations',
        method: 'GET',
        params: params
    }).then(res => res);
};
// 搜索员工
export const searchUser = params => {
    return request({
        url: 'api-auth/tenantUserInfos',
        method: 'GET',
        params: params
    }).then(res => res);
};
